export default __webpack_public_path__ + "static/info_sale_worldwide-31a6b77c92536c2a8442d225400e10fb.svg";